import i18n from 'vuex-i18n'

export default i18n.store



// WEBPACK FOOTER //
// ./src/store/modules/i18n.js